import { Outlet } from 'react-router-dom';
import ComingSoonPage from '@/pages/ComingSoonPage';
import { AppConfig } from '@/config/app';


interface ComingSoonWrapperProps {
  children?: React.ReactNode;
}

export const ComingSoonWrapper: React.FC<ComingSoonWrapperProps> = ({ children }) => {
  console.log(AppConfig.isComingSoonMode)
  if (AppConfig.isComingSoonMode) {
    return <ComingSoonPage />;
  }

  // If the mode is off, just render the actual page component
  return <>{children ?? <Outlet />}</>;
};
